import React, { useEffect, useRef, useState } from "react"
import { Text, Animated } from "react-native"

/**
 * Un texte qui s'écrit lettre à lettre, avec un curseur qui clignote tant
 * qu'il écrit. Pour le nom d'une matière à l'arrivée du programme : ce qui
 * vient d'être composé s'écrit, il ne s'affiche pas. Court par construction —
 * on ne tape pas un paragraphe.
 */
const FunnelTypewriter = ({ text, delay = 0, speed = 42, style, onDone }) => {
    const [shown, setShown] = useState(0)
    const blink = useRef(new Animated.Value(1)).current
    const done = shown >= text.length

    useEffect(() => {
        setShown(0)
        let timer = null
        const start = setTimeout(() => {
            timer = setInterval(() => {
                setShown((n) => {
                    if (n + 1 >= text.length) {
                        clearInterval(timer)
                        onDone?.()
                    }
                    return n + 1
                })
            }, speed)
        }, delay)
        return () => {
            clearTimeout(start)
            if (timer) clearInterval(timer)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text])

    useEffect(() => {
        if (done) return undefined
        const loop = Animated.loop(
            Animated.sequence([
                Animated.timing(blink, {
                    toValue: 0,
                    duration: 380,
                    useNativeDriver: true,
                }),
                Animated.timing(blink, {
                    toValue: 1,
                    duration: 380,
                    useNativeDriver: true,
                }),
            ])
        )
        loop.start()
        return () => loop.stop()
    }, [done, blink])

    return (
        <Text style={style}>
            {text.slice(0, shown)}
            {!done ? (
                <Animated.Text style={[style, { opacity: blink }]}>
                    |
                </Animated.Text>
            ) : null}
        </Text>
    )
}

export default FunnelTypewriter
